/**
 * @file CompanyAdmin.ts
 * @brief Company Admin's own icon: the company building, approved (Building2 still means "a company").
 *
 * @details
 * Mirrors the mobile app's `FRONTEND/src/shared/components/icons/CompanyAdmin.ts`
 * (DES 08-10-2026, app-specific icons): identical geometry and keys, built
 * with lucide-react's `createLucideIcon` so it takes the same props
 * (size, className, strokeWidth, color) as every lucide icon.
 *
 * @author DES
 * @date 08-10-2026
 */

import { createLucideIcon } from "lucide-react";

export const CompanyAdmin = createLucideIcon("CompanyAdmin", [
  ["path", { d: "M4 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v6", key: "building" }],
  ["path", { d: "M8 7h4", key: "floor-1" }],
  ["path", { d: "M8 11h4", key: "floor-2" }],
  ["path", { d: "M8 15h2", key: "floor-3" }],
  ["path", { d: "M4 21h7", key: "ground" }],
  ["circle", { cx: "18", cy: "18", r: "4", key: "badge" }],
  ["path", { d: "m16.2 18 1.3 1.3 2.4-2.6", key: "tick" }],
]);

export default CompanyAdmin;
